/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrStrData } from './genericApiResponseDictStrStrData';
import type { GenericApiResponseDictStrStrMessage } from './genericApiResponseDictStrStrMessage';
import type { GenericApiResponseDictStrStrPagination } from './genericApiResponseDictStrStrPagination';
import type { GenericApiResponseDictStrStrError } from './genericApiResponseDictStrStrError';

export interface GenericApiResponseDictStrStr {
  data?: GenericApiResponseDictStrStrData;
  message?: GenericApiResponseDictStrStrMessage;
  pagination?: GenericApiResponseDictStrStrPagination;
  error?: GenericApiResponseDictStrStrError;
  statusCode?: number;
}
